import React from 'react'
import '../css/spinner.css'

const Spinner = () => {
    return (
        <div className='spinner'></div>
    )
}

export default Spinner